/** @format */

import React, { Component } from 'react';
import I18n from '../../components/Translate/I18n';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import CardIcon from 'components/Card/CardIcon.jsx';
import CardHeader from './../Card/CardHeader';

import adescomStyle from 'assets/jss/adescom/adescomStyle';
import oplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';

class CardHeaderExt extends Component {
    render() {
        const { classes, icon, trans, color, additionalContent, transValueObject } = this.props;
        return (
            <CardHeader color={color} icon>
                {/*<CardIcon color={colors}>{icon}</CardIcon>*/}
                <h4 className={classes.cardIconTitle}>
                    {trans && !transValueObject && <I18n trans={trans} />}
                    {trans && transValueObject && <I18n trans={trans} valueObject={transValueObject} />}
                    {additionalContent && <React.Fragment>{additionalContent}</React.Fragment>}
                </h4>
            </CardHeader>
        );
    }
}

CardHeaderExt.propsTypes = {
    classes: PropTypes.object.isRequired,
    color: PropTypes.string,
    trans: PropTypes.string,
    icon: PropTypes.object,
    additionalContent: PropTypes.object,
    transValueObject: PropTypes.object,
};

export default withStyles(oplAppStyle)(CardHeaderExt);
